import { render, staticRenderFns } from "./BRRDDetail.vue?vue&type=template&id=fe766bf6&"
import script from "./BRRDDetail.vue?vue&type=script&lang=js&"
export * from "./BRRDDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports